<dsd-container>
  @if (!isAppMobile) {
    <h1 class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
      {{ 'validation.sousTitre' | translate }}
    </h1>
  }

  <h2 id="titreConfirmation" tabindex="-1">
    @if (afficherVarianteTextePartiel) {
      <ng-content select="[confirmation-titre-partiel]"></ng-content>
    } @else {
      <ng-content select="[confirmation-titre]"></ng-content>
    }
  </h2>

  @if (afficherVarianteTextePartiel) {
    <p>{{ 'confirmation.descriptionPartiel' | translate }}</p>
  } @else {
    <p>{{ 'confirmation.description' | translate }}</p>
  }

  <p class="dsd-mb-xs">
    <span class="dsd-pb-xs dsd-d-block">{{
      'confirmation.delaiTraitement.dureeLibelle' | translate
    }}</span>
    <dsd-tag icon-name="contenus_contour_temps"
      >{{ 'confirmation.delaiTraitement.duree' | translate }}
    </dsd-tag>
  </p>

  @if (afficherEtapes) {
    <div class="max-width">
      <div class="dsd-hr dsd-hr-bc-dark dsd-mt-md"></div>
      <h3 class="dsd-t-5">
        {{
          (contientPlusDUneEtape
            ? 'confirmation.etapes.titrePluriel'
            : 'confirmation.etapes.titreSingulier'
          ) | translate
        }}
      </h3>
      @if (afficherSuccesPartiel) {
        <dsd-container
          background-color="dsd-color-background-decorative-petroleum-100"
          [margin]="!contientPlusDUneEtape ? 'none' : 'md'"
          border-radius="sm"
        >
          <p class="dsd-mb-0">
            {{ 'confirmation.partiel.debut' | translate }}
            <ng-content select="[confirmation-partiel-contexte]"></ng-content>
            {{ 'confirmation.partiel.pour' | translate }}
            {{ secteursTraduitsOrdonnees }}.
          </p>
          @if (!contientPlusDUneEtape) {
            <div class="dsd-mt-md">
              <app-bouton-nous-joindre></app-bouton-nous-joindre>
            </div>
          }
        </dsd-container>
      }
      @for (etape of etapes; track etape.id) {
        <dsd-container
          background-color="dsd-color-background-decorative-petroleum-100"
          [margin]="etape.id === this.refSteps.nativeElement.lastElementChild.id ? 'none' : 'md'"
          border-radius="sm"
        >
          <p class="dsd-mb-0">{{ etape.innerText }}</p>
          @if (!contientPlusDUneEtape && peutAfficherNousJoindre(etape)) {
            <div class="dsd-mt-md">
              <app-bouton-nous-joindre></app-bouton-nous-joindre>
            </div>
          }
        </dsd-container>
      }
      @if (contientPlusDUneEtape) {
        <div class="dsd-mt-md">
          <app-contactez-nous niveauTitre="h4"></app-contactez-nous>
        </div>
      }
    </div>
  }
</dsd-container>

<app-bouton-retour-coordonnees></app-bouton-retour-coordonnees>
